<div
    class="flex flex-col flex-auto items-center sm:justify-center min-w-0 sm:p-8 md:py-16 md:px-16"
>
    <div class="flex w-full h-full rounded-2xl shadow-2xl overflow-hidden">
        <div
            class="flex items-center justify-center h-full p-16 lg:px-28 overflow-hidden border-r-2"
        >
            <ng-lottie [options]="options" class="scale-125" />
        </div>
        <div class="w-full py-8 px-4 sm:p-12 md:p-16">
            <div
                class="flex flex-col w-full h-full justify-center max-w-90 sm:w-90 mx-auto sm:mx-0"
            >
                <!-- Title -->
                <div
                    class="text-4xl font-extrabold tracking-tight leading-tight text-secondary"
                    >Forgot password?</div
                >
                <div
                    class="flex text-secondary items-baseline mt-0.5 font-medium"
                >
                    <div>Enter registered email and click the button below</div>
                </div>

                <!-- Alert -->
                <zop-alert
                    class="mt-8 -mb-4"
                    *ngIf="showAlert"
                    [appearance]="'outline'"
                    [showIcon]="false"
                    [type]="alert.type"
                    [@shake]="alert.type === 'error'"
                >
                    {{ alert.message }}
                </zop-alert>

                <!-- Forgot password form -->
                <form
                class="mt-8"
                [formGroup]="forgotPasswordForm"
                #forgotPasswordNgForm="ngForm">

                <!-- Email field -->
                <mat-form-field class="w-full">
                    <mat-label>Email address</mat-label>
                    <input
                        id="email"
                        matInput
                        [formControlName]="'email'">
                    <mat-error *ngIf="forgotPasswordForm.get('email')?.hasError('required')">
                        Email address is required
                    </mat-error>
                    <mat-error *ngIf="forgotPasswordForm.get('email')?.hasError('email')">
                        Please enter a valid email address
                    </mat-error>
                </mat-form-field>

                <!-- Submit button -->
                <button
                    class="fuse-mat-button-large w-full mt-3"
                    mat-flat-button
                    [color]="'primary'"
                    [disabled]="forgotPasswordForm.disabled"
                    (click)="sendResetLink()">
                    <span *ngIf="!forgotPasswordForm.disabled">
                        Send reset link
                    </span>
                    <mat-progress-spinner
                        *ngIf="forgotPasswordForm.disabled"
                        [diameter]="24"
                        [mode]="'indeterminate'"></mat-progress-spinner>
                </button>

                <!-- Form footer -->
                <div class="mt-8 text-md font-medium text-secondary">
                    <span>Return to</span>
                    <a
                        class="ml-1 text-primary-500 hover:underline"
                        [routerLink]="['/sign-in']">sign in
                    </a>
                </div>

            </form>
            </div>
        </div>
    </div>
</div>
